<template>
  <div class="case-contrainer">
    <div class="book-info">
      <div class="title">
          <span class="word-middle" style="padding-left: 0;">案件信息</span>
          <el-tooltip class="item" effect="dark"  placement="top" content="仅支持word文档，pdf文档，txt文本以及html文件">
            <span class="upload-icon">
                <input @change="uploadBook" v-if="showBook" type="file" class="upload-book" />
                <el-button class="upload-btn word-normal" icon="el-icon-upload2" :loading="uploadIng">
                  上传起诉书
                </el-button>
            </span>
          </el-tooltip>
      </div>
      <div class="bar">
          <!-- <div style="height: calc(100% - 20px);outline:none;" contenteditable="true" ref="bar" @input="changeText($event)"> -->
          <div style="height: calc(100% - 20px);outline:none;">
              <div class="progress">
                  <p class="word-normal" style="color:#4F5E7B;font-size:14px;font-weight:normal" v-html="highlight(content,highLightList)">
                      
                  </p>
              </div>
          </div>
          <div class="placeholder" v-if="!content">
              <div class="copy"><img src="./images/copy.png" alt=""></div>
              <p>点击右键【粘贴】完整的起诉文书或点击右上角【上传起诉书】预测</p>
          </div>
      </div>
    </div>
    <div class="case-list">
      <div class="title">
        <span class="word-middle">案件被告人信息</span>
      </div>
      <div class="case-panel">
        <p class="case-top word-middle">根据你提供的案件信息，{{ isThird ? '' : '小包公' }}已智能识别出被告人姓名和对应的罪名：</p>
        <div>
          <table border="1" class="word-middle" id="standardization" cellspacing="0" cellpadding="0">
            <tr class="sky-bg">
              <th colspan="1"><div>被告人</div></th>
              <th colspan="5"><div>罪名</div></th>
            </tr>
            <tr v-for="(item,index) in crimeList" :key="index">
              <td :rowspan="item.count" v-if="item.count">
                <div class="key center">{{item.opponent}}</div>
              </td>
              <td colspan="5">
                <div class="reason">
                  <span class="val">{{item.reason}}</span>
                  <div>
                      <el-button type="primary" @click="goStep(item)">预测量刑</el-button>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
     

     <el-dialog width="450px" class="tipDialog" custom-class="tipCustomDialog" :visible.sync="showNoMatch" :title="'提示'">
        <div style="padding: 0 15px;">
            <div class="word-middle" style="color: #5C79B0;line-height:22px;margin-top: 15px">你粘贴的整段案件信息没有被告人的罪名，请加上罪名再进行预测。</div>
        </div>
        <div style="background:#EDF1FA;padding: 15px 0;margin-top:20px;text-align:right;border-radius:0 0 3px 3px">
            <el-button @click="showNoMatch = false" style="width: 100px;margin-right: 15px;" type="primary">我知道了</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
       model:{},
       reportList:[],
       content: "",
       showBook: true,
       highLightList:[],
       matchList: [],
       crimeList: [],
       city: "",
       uploadIng: false,
       confilctCrime: "",
       showNoMatch: false
    };
  },

  components: {},
  computed: {
      ...mapGetters(['isThird']),
  },

  mounted(){
    this.fetchData()
  },

  methods: {
    fetchData(){
      if(sessionStorage.getItem('bookId')){
        this.httpGet(`case/extract/predictions/${sessionStorage.getItem('bookId')}`).then((data)=>{
              if(data && data.statusCode == 1){
                  this.matchList = data.data.opponents;
                  this.city = data.data.city;
                  this.matchList.forEach(v=>{
                    v.crimes.forEach(ele=>{
                      var find  = _.find(this.crimeList,{opponent: v.name})
                      let model = {
                        reason: ele.reason,
                        opponent: v.name
                      }
                      !find?model.count = v.crimes.length:''
                      this.crimeList.push(model)
                    })
                  })
              }else{
                  this.$message({
                    message: data.data.message,
                    type: 'warning'
                  })
              }
        })
        this.content = sessionStorage.getItem('content');
      }
    },
    highlight(value,keyword){
        let replaceValue = ''
          if (value && keyword && keyword.length>0) {
              var reg = new RegExp('(' + keyword.join('|') + ')', 'g')
              replaceValue = value.replace(reg, '<span style="background:rgba(230, 162, 60, 1)">$1</span>')
              return replaceValue
          } else {
              return value;
          }
    },
    goStep(col){
      let reason = col.reason;
      if(col.reason == '走私毒品罪' || col.reason == '贩卖毒品罪' || col.reason == '运输毒品罪' || col.reason == '制造毒品罪'){
        reason = '走私、贩卖、运输、制造毒品罪'
      }
      this.$router.push({
        path: '/forecast/step',
        query:{
          city: this.$route.query.city || this.city || sessionStorage.getItem('city'),
          crime: reason,
          home: true,
          opponent: col.opponent
        }
      })
    },
    uploadBook(event){
        if(event.target.files[0]){
            this.content = "";
            this.confilctCrime = "";
            this.matchList = [];
            var formData = new FormData();
            formData.append('file', event.target.files[0])
            formData.append('username',this.$route.query.username)
            formData.append('crime',this.$route.query.crime)
            sessionStorage.removeItem('bookId');
            this.uploadIng = true;
            this.uploadfile('case/extract/upload',formData).then((data)=>{
                this.uploadIng = false
                this.showBook = false
                if(data && data.statusCode == 1){
                    this.showBook = true
                    if(data.data.id){
                        sessionStorage.setItem('bookId',data.data.id);
                    }
                    if(data.data.city){
                        this.city = data.data.city;
                    }
                    if(data.data.opponents){
                      if(data.data.opponents.length==1 && data.data.opponents[0].crimes.length==1){
                          this.confilctCrime = data.data.opponents[0].crimes[0].reason;
                          if(this.confilctCrime == '走私毒品罪' || this.confilctCrime == '贩卖毒品罪' || this.confilctCrime == '运输毒品罪' || this.confilctCrime == '制造毒品罪'){
                              this.confilctCrime = '走私、贩卖、运输、制造毒品罪'
                          }
                      }else if(data.data.opponents.length > 1 || (data.data.opponents.length && data.data.opponents[0].crimes.length>0)){
                          this.matchList = data.data.opponents;
                      }
                    } 
                    data.data.paragraphs.forEach(v=>{
                        if(v.text){
                            this.content += ('<div>'+v.text+'</div>')
                        }
                    })
                    sessionStorage.removeItem('content')
                    sessionStorage.setItem('content',this.content)

                    if(this.city && this.confilctCrime){
                        this.$router.push({
                            path: '/forecast/step',
                            query: {
                                city: this.city,
                                crime: this.confilctCrime
                            }
                        })
                    }else if(this.city && this.matchList.length>0){
                        this.$router.push({
                            path: '/forecast/home',
                            query: {
                                city: this.city,
                                bookId: sessionStorage.getItem('bookId')
                            }
                        })
                    }else if(this.city && !this.confilctCrime && this.matchList.length == 0){
                        this.showNoMatch = true
                    }

                    if(!data.data.city && !this.city){
                        this.$message({
                            type: 'warning',
                            message: '未提取到地区信息，请选择地区再进行下一步'
                        })
                        return;
                    }
                }
            })
        }
      },
    changeText(event){
        if(!this.content && event.target.textContent){
            let express = '</p>'
            let params = {
                content: event.target.innerHTML.replace(new RegExp(express,'g'),'\n').replace(/<p>/g,'').replace(/(<(.[^>]*)>)|( )/g,""),
                crime: this.$route.query.crime
            }
            

            var formData = new FormData();
            formData.append('content', params.content)
            formData.append('username',this.$route.query.username)
            formData.append('crime',this.$route.query.crime)
            this.uploadfile('case/extract/upload',formData).then((data)=>{
                if(data && data.statusCode == 1){
                    this.content = params.content;
                    if(data.data.id){
                        sessionStorage.setItem('bookId',data.data.id);
                    }
                    if(data.data.city){
                        this.city = data.data.city;
                    }
                    if(data.data.opponents){
                        if(data.data.opponents.length==1 && data.data.opponents[0].crimes.length==1){
                            this.confilctCrime = data.data.opponents[0].crimes[0].reason;
                            if(this.confilctCrime == '走私毒品罪' || this.confilctCrime == '贩卖毒品罪' || this.confilctCrime == '运输毒品罪' || this.confilctCrime == '制造毒品罪'){
                                this.confilctCrime = '走私、贩卖、运输、制造毒品罪'
                            }
                        }else if(data.data.opponents.length > 1 || (data.data.opponents.length && data.data.opponents[0].crimes.length>0)){
                            this.matchList = data.data.opponents;
                        }
                    } 
                }
            })
        }    

        if (window.getSelection) { //ie11 10 9 ff safari
            event.target.focus(); //解决ff不获取焦点无法定位问题
            var range = window.getSelection(); //创建range
            range.selectAllChildren(event.target); //range 选择obj下所有子内容
            range.collapseToEnd(); //光标移至最后
        } else if (document.selection) { //ie10 9 8 7 6 5
            var range = document.selection.createRange(); //创建选择对象
            //var range = document.body.createTextRange();
            range.moveToElementText(event.target); //range定位到obj
            range.collapse(false); //光标移至最后
            range.select();
        }
    }
  }
}

</script>
<style lang="less" scoped>
.case-contrainer{
  margin: 10px;
  height: calc(100vh - 85px);
  display: flex;
  justify-content: space-between;
  .book-info{
      width: 25%;
      min-width: 25%;
      margin-right: 10px;
      background:rgba(255,255,255,1);
      border:1px solid @lineColor;
      .title{
          background: @headerColor;
          color: @wordColor1;
          height: 35px;
          line-height: 35px;
          padding-left: 12px;
          display: flex;
          justify-content: space-between;
          .upload-icon{
              display: inline-block;
              margin-right: 5px;
              position: relative;
              border-radius: 3px;
              cursor: pointer;
              a{
                  color: #fff;
              }
              .upload-book{
                 position: absolute;
                  width: 100%;
                  opacity: 0;
                  height: 100%;
                  cursor: pointer;
                  left: 0;
                  top: 0;
              }
              .upload-btn{
                  background: @mainColor;
                  padding: 0 10px;
                  color: #fff;
                  line-height: 25px;
                  height: 25px;
                  border: none;
                  outline: none;
              }
          }
      }
      .bar{
          height: calc(100vh - 110px);
          overflow-y: auto;
          overflow-x: hidden;
          position: relative;
          outline: none;
          .placeholder{
              border-radius:4px;
              left: 50%;
              top: 50%;
              padding: 40px 0;
              transform: translate(-50%,-50%);
              color: @wordColor2;
              line-height: 22px;
              text-align: center;
              width: 250px;
              border: 1px dashed @lineColor;
              position: absolute;
              p{
                  margin: 0 15px;
              }
              .copy{
                  width: 35px;
                  margin: 0 auto 20px auto;
                  img{
                      width: 100%;
                  }
              }
          }
      }
      .progress{
          margin: 10px;
          padding: 5px;
          height: 100%;
          position: relative;
          background:rgba(215,229,249,0.2);
          border:1px solid @lineColor;
          box-sizing: border-box;
          overflow-y: auto;
          p{
              color:@wordColor1;
              padding-bottom: 10px;
              line-height: 24px;
          }
          span{
              color: @wordColor1;
              line-height: 30px;
          }
          .get-tip{
              padding: 0 10px;
              line-height: 22px;
              background:rgba(45,64,94,1);
              position: absolute;
              cursor: pointer;
              border-radius: 3px;
              .no-match{
                  color: #fff;
                  font-size: 14px;
                  margin: 6px 0;
              }
              .plot-list{
                  margin: 16px 0;
                  min-width: 200px;
                  color: #fff;
                  font-size: 14px;
                  .macth-plot span{
                      display: inline-block;
                      height: 28px;
                      margin-top: 5px;
                      background:rgba(79,94,123,1);
                      border-radius: 3px;
                      color: #ECF1FA;
                      padding: 0 8px;
                  }
                  .macth-plot .cur{
                      background: @mainColor;
                  }
              }
          }
          .get-tip::after{
              position: absolute;
              display: block;
              width: 0;
              height: 0;
              border-style: solid;
              border-color:rgba(45,64,94,1) transparent transparent transparent;
              content: "";
              bottom: -11px;
              border-width: 6px;
          }
      }
  }
  .case-list{
    background: #fff;
    border: 1px solid @lineColor;
    flex: 1;
  }
  .title{
    background: @headerColor;
    line-height: 35px;
    span{
      padding-left: 18px;
      color: @wordColor1;
    }
  }
  .case-panel{
    margin: 15px;
    .case-top{
      margin-bottom: 10px;
      color: @wordColor1;
    }
    table{
      width: 100%;
      border-collapse: collapse;
      position: relative;
      td>div,th>div{
        height: 45px;
        line-height: 45px;
        vertical-align: middle;
      }
      tr, td, th{
        vertical-align: middle;
      }
      .key{
        color: @wordColor2;
      }
      .val{
        color: @wordColor1;
      }
      .center{
        text-align: center;
      }
      .line{
        color: #BAC9DF;
        margin: 0 5px;
      }
    }

    #standardization{
        border: 1px solid @lineColor;
        margin: 0 0 10px 0;
        border-collapse: collapse;
        width: 100%;
        tr{
            border: 1px solid @lineColor
        }
        td{
            border: 1px solid @lineColor
        }
    }
    .sky-bg{
      background: rgba(215,229,249,0.5);
    }
    .reason{
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      .el-button{
        margin: 5px 0;
        height: 34px;
        line-height: 0px;
      }
    }
    
  }
}
</style>


// WEBPACK FOOTER //
// src/views/forecast/home.vue